module.exports = __webpack_public_path__ + "assets/img/lunttw.6315e2c8.png";